/**
 * Karma store — admin-only. Loads karma scores on demand and provides
 * a lookup by userId. Invisible to non-SUPER_ADMIN users.
 */
import { create } from 'zustand';
import { adminApi } from '@/api/users';

interface KarmaState {
  scores: Map<string, number>;
  loaded: boolean;
  /** Load karma map from server. No-op if already loaded. Safe to call for non-admins (silently fails). */
  load: () => Promise<void>;
  /** Get karma score for a user. Returns null if not loaded or user has no score. */
  get: (userId: string) => number | null;
}

export const useKarmaStore = create<KarmaState>((set, getState) => ({
  scores: new Map(),
  loaded: false,

  async load() {
    if (getState().loaded) return;
    const map = await adminApi.getKarmaMap(1000);
    set({ scores: map, loaded: true });
  },

  get(userId: string) {
    return getState().scores.get(userId) ?? null;
  },
}));
